<template>
    <div>
       <h4 class="title">組織查詢</h4>
       <div class="member_content">
<section>
  <form class="form-inline">
    <div class="form-group">
      <input type="text" v-model="membername" placeholder="請填寫姓名"/>
    </div>
    <div class="form-group">
      <datepicker v-model="choosemonth" language="zh" format="yyyy-MM-dd" placeholder="請選擇日期"></datepicker>
    </div>
    <div class="form-group">
      <button type="button" class="btn btn-sm btn-success" :disabled="this.searchFlag" @click="doFilter()">過濾</button>
      <button type="button" class="btn btn-sm btn-danger" @click="reset()">清除</button>
    </div>
  </form>
</section>
<hr/>
<div class="row">
  <div class="col-md-2 col-xs-3">會員編號</div>
  <div class="col-md-2 col-xs-3">姓名</div>
  <div class="col-md-3 col-xs-4">信箱</div>
  <!-- <div class="col-md-5 col-xs-2">加入時間</div> -->
</div>
<div class="row" v-for="(row, index) in this.team">
  <div class="col-md-2 col-xs-3">1-{{row.org_mid}}</div>
  <div class="col-md-2 col-xs-3">{{row.org_name}}</div>
  <div class="col-md-3 col-xs-4"><p class="text-success">{{row.email}}</p></div>
  <div class="col-md-5 col-xs-6 col-xs-offset-6">{{row.created_at}}</div>
  <div class="col-md-12">
    <div class="row" v-for="(data, idx) in row.dwon2">
      <div class="col-md-2 col-xs-3">
        <div class="row">
          <div class="col-md-offset-2 col-md-10">2-{{data.org_mid}}</div>
        </div>
      </div>
      <div class="col-md-2 col-xs-3">{{data.org_name}}</div>
      <div class="col-md-3 col-xs-4"><p class="text-success">{{data.email}}</p></div>
      <div class="col-md-5 col-xs-6 col-xs-offset-6">{{data.created_at}}</div>

    <div class="col-md-12">
      <div class="row" v-for="(l3, idx) in data.down3">
        <div class="col-md-2 col-xs-3">
          <div class="row">
            <div class="col-md-offset-4 col-md-10">3-{{l3.org_mid}}</div>
          </div>
        </div>
        <div class="col-md-2 col-xs-3">{{l3.org_name}}</div>
        <div class="col-md-3 col-xs-4"><p class="text-success">{{l3.email}}</p></div>
        <div class="col-md-5 col-xs-6 col-xs-offset-6">{{l3.created_at}}</div>
      </div>
    </div>

    </div>
   </div>
</div>
      </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'

export default {
  name: 'Team',
  components: {
    Datepicker
  },
  data () {
    return {
      memberurl: this.$store.getters.getMemberAPI,
      userID: this.$store.getters.getUserID,
      token: this.$store.getters.getToken,
      team: [],
      originData: [],
      choosemonth: '',
      membername: ''
    }
  },
  mounted: function () {
    let id = this.userID
    this.$http.get(this.memberurl + '/member_team', {params: {token: this.token, id: id}}).then(function (res) {
      let data = res.body.data
      // console.log(data)
      this.team = data.org
      this.originData = data.org
    }, function () {
      console.log('failed')
    })
  },
  methods: {
    ...mapActions([
      'GET_NEWS'
    ]),
    doFilter () {
      // let membername = this.membername
      // console.log('====membername===' + membername)
    },
    reset () {
      this.membername = ''
      this.choosemonth = ''
    }
  },
  watch: {
    membername: {
      handler: function (val, oldVal) {
        this.team = this.originData.filter(function (value) {
          return value.org_name.indexOf(val) >= 0
        })
      }
    },
    choosemonth: {
      handler: function (val, oldVal) {
        this.team = this.originData.filter(function (value) {
          let date = moment(value.created_at).format('YYYY-MM-DD')
          let inputDate = moment(val).format('YYYY-MM-DD')
          return date === inputDate
        })
      }
    }
  },
  computed: {
    ...mapGetters([
      'getNews'
    ])
  }
}
</script>



// WEBPACK FOOTER //
// Team.vue?73c513ba